/** @module SharedConstants */

/**
 * @typedef SharedConstants {Object}
 * @property MESSAGE_TYPES {{SYSTEM: string, FROM_OPERATOR: string, FROM_USER: string}} - Chat message types
 * @property CHAT_REQUEST_STATUS {{ENDED_OPERATOR_LOST_CONNECTION: number, ESCALATING: number, ENDED_VISITOR_LOST_CONNECTION: number, ENDED_TIMEOUT: number, ENDED: number, ENDED_ADMINISTRATOR: number, NO_AVAILABLE_OPERATORS: number, VISITOR_LOST_CONNECTION_DURING_REQUEST: number, TRANSFERRING: number, ACCEPTED: number, ENDED_OPERATOR: number, ENDED_BUSY: number, ENDED_NOT_PICKED_UP: number, REQUESTED: number, ENDED_VISITOR: number, HOLD_BEFORE_REQUEST: number}}
 * @global
 */

// Message Types
export const WS_MSG_SYSTEM_MSG = 'systemMessage';
export const WS_MSG_HEARTBEAT = 'heartbeat';

export const ADMIN_SEND_COMMAND_TO_SPA = 'sendCommandToSpa';
export const SPA_COMMAND_RESPONSE = 'spaCommandResponse';

export const ADMIN_SEND_COMMAND_TO_MASTER = 'sendCommandToMaster';
export const MASTER_COMMAND_RESPONSE_TO_ADMIN = 'masterCommandResponseToAdmin';

export const TRANSLATION_STATUS_NOT_NEEDED = 0;
export const TRANSLATION_STATUS_NEEDS_TRANSLATION = 1;
export const TRANSLATION_STATUS_PROCESSING_TRANSLATION = 2;
export const TRANSLATION_STATUS_COMPLETED_TRANSLATION = 3;

export const CHAT_NOT_EXISTS_REASONS = {
  OPERATOR_LOST_CONNECTION : 'ended-operator-lostconnection',
  OPERATOR_ENDED_CHAT: 'ended-operator'
};

/**
 * @typedef {Object} MESSAGE_TYPES
 * @property {string} SYSTEM
 * @property {string} FROM_OPERATOR
 * @property {string} FROM_USER
 */
export const MESSAGE_TYPES = {
  FROM_OPERATOR: 'FROM_OPERATOR',
  FROM_USER: 'FROM_USER',
  SYSTEM: 'SYSTEM'
};

export const CHAT_STATUS = {
  REQUESTED: 'requested',
  ACCEPTED: 'accepted',
  FINISHED: 'finished'
};

/** @type {SharedConstants['CHAT_REQUEST_STATUS']} */
export const CHAT_REQUEST_STATUS = {
  REQUESTED: 1,
  ACCEPTED: 2,
  ENDED: 3,
  TRANSFERRING: 4,
  ESCALATING: 5,
  ENDED_OPERATOR: 6,
  ENDED_OPERATOR_LOST_CONNECTION: 7,
  ENDED_VISITOR: 8,
  ENDED_VISITOR_LOST_CONNECTION: 9,
  ENDED_ADMINISTRATOR: 10,
  ENDED_TIMEOUT: 12,
  NO_AVAILABLE_OPERATORS: 13,
  ENDED_BUSY: 14,
  VISITOR_LOST_CONNECTION_DURING_REQUEST: 15,
  HOLD_BEFORE_REQUEST: 16,
  ENDED_NOT_PICKED_UP: 17
};

export const ADMIN_FUNCTION_CALL = 'adminFunction';

export const CONSOLE_GREEN = '\x1b[32m';
export const CONSOLE_YELLOW = '\x1b[33m';

export const WS_STATUS = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3
};

export const ACTION_TYPE_SUBMIT_SESSION = '@@UX_LOGGER/GET_STORE';

// CLUSTER STATUS
export const CS_cpusModel = 'cpu';
export const CS_cpusCount = 'cpuc';
export const CS_totalMemGB = 'tmem';
export const CS_usedMemGB = 'umem';
export const CS_wsSendToMasters = 'wms';
export const CS_PublicIpAddress = 'ip';
export const CS_PrivateIpAddress = 'privateIp';
export const CS_ImpulseUrlPortMappingInUse = 'IMPULSE_URL_PORT_MAPPING_IN_USE';
export const CS_publicPort = 'publicPort';
export const CS_cpuu = 'cpuu';
export const CS_memu = 'memu';
export const CS_workerWsPort = 'port';
export const CS_workerWsPorts = 'ports';
export const CS_externalHostname = 'hostname';

export const STATS_CHECKER_ERROR_LOG_PREFIX = '[INVALID_STATS_DETECTED]';
export const MAX_UPDATED_STATS_TIME_THRESHOLD = 60 * 1000; // a minute

// Received user messages

export const CS_age = 'a';
export const CS_ping = 'ping';
export const CS_time = 'updated';
export const CS_instanceIndex = 'idx';
export const CS_leader = 'leader';
